function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg096CapeVerde(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    y: 322.783,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 22.261
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 300.522,
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 22.261
  }), /*#__PURE__*/React.createElement("rect", {
    y: 345.043,
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 22.261
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "180.384,261.278 183.388,270.526 193.113,270.526 185.246,276.242 188.251,285.49    180.384,279.775 172.517,285.49 175.522,276.242 167.656,270.526 177.38,270.526  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "180.384,382.337 183.388,391.584 193.113,391.584 185.246,397.3 188.251,406.548    180.384,400.833 172.517,406.548 175.522,397.3 167.656,391.584 177.38,391.584  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "124.033,341.395 127.037,350.643 136.762,350.643 128.896,356.359 131.9,365.607    124.033,359.891 116.166,365.607 119.171,356.359 111.304,350.643 121.029,350.643  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "145.557,273.383 148.561,282.632 158.286,282.632 150.42,288.347 153.424,297.596    145.557,291.88 137.69,297.596 140.695,288.347 132.828,282.632 142.553,282.632  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "111.304,311.467 121.027,311.469 124.032,302.219 127.037,311.467 136.762,311.466    128.895,317.183 131.9,326.432 124.032,320.717 116.166,326.43 119.17,317.183  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "137.69,392.676 140.695,383.43 132.827,377.714 142.552,377.714 145.557,368.465    148.562,377.712 158.286,377.712 150.419,383.429 153.423,392.677 145.556,386.962  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "236.714,341.395 233.71,350.643 223.986,350.643 231.851,356.359 228.847,365.607    236.714,359.891 244.581,365.607 241.576,356.359 249.443,350.643 239.718,350.643  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "215.19,273.383 212.186,282.632 202.461,282.632 210.327,288.347 207.323,297.596    215.19,291.88 223.057,297.596 220.052,288.347 227.919,282.632 218.194,282.632  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "249.443,311.467 239.721,311.469 236.715,302.219 233.71,311.467 223.986,311.466    231.853,317.183 228.847,326.432 236.715,320.717 244.581,326.43 241.577,317.183  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "223.057,392.676 220.052,383.43 227.919,377.714 218.195,377.714 215.19,368.465    212.185,377.712 202.461,377.712 210.328,383.429 207.324,392.677 215.191,386.962  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg096CapeVerde);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };